<nav class="nav-bar">
  <div fxLayout="column" class="vertical-menu">
    <a (click)="backClicked()">
      <mat-icon class="content" matTooltip="Go Back"
        >keyboard_backspace</mat-icon
      >
    </a>
    <a routerLink="/">
      <mat-icon class="content">home</mat-icon>
    </a>

    <!-- <mat-icon
      *ngIf="currentPage.includes('/distribution/international/parts')"
      class="content"
      [matMenuTriggerFor]="country"
      >format_indent_increase</mat-icon
    >
    <mat-menu #country="matMenu">
      <div class="plMenuCSS">
        <button mat-menu-item>
          <mat-icon>format_indent_decrease</mat-icon>close panel
        </button>
        <button mat-menu-item routerLink="distribution/international/parts">
          All
        </button>
        <button mat-menu-item routerLink="distribution/international/parts/AME">
          AME
        </button>
        <button
          mat-menu-item
          routerLink="distribution/international/parts/Arabia-JV"
        >
          Arabia JV
        </button>
        <button
          mat-menu-item
          routerLink="distribution/international/parts/Asia-Pacific"
        >
          Asia Pacific
        </button>
        <button
          mat-menu-item
          routerLink="distribution/international/parts/East-Asia"
        >
          East Asia
        </button>
        <button
          mat-menu-item
          routerLink="distribution/international/parts/Greater-Europe"
        >
          Greater Europe
        </button>
        <button
          mat-menu-item
          routerLink="distribution/international/parts/India"
        >
          India
        </button>
        <button
          mat-menu-item
          routerLink="distribution/international/parts/Latin-America"
        >
          Latin America
        </button>
      </div>
    </mat-menu> -->
    <div class="block" *ngIf="currentPage.includes('/ebu/engines/')">
      <mat-icon class="content" [matMenuTriggerFor]="country"
        >format_indent_increase</mat-icon
      >
      <mat-menu #country="matMenu">
        <div class="plMenuCSS">
          <button mat-menu-item>
            <mat-icon>format_indent_decrease</mat-icon>close panel
          </button>
          <button
            mat-menu-item
            [ngStyle]="{
              background: activeItem === 'sales' ? '#950101' : ''
            }"
          >
            <span>
              <mat-icon>price_change</mat-icon>
              Sales Realization
            </span>
          </button>

          <button
            mat-menu-item
            routerLink="ebu/engines/sales-realization/All"
            (click)="setActiveItem('all')"
            [ngStyle]="{
              background: activeItem === 'all' ? '#950101' : ''
            }"
          >
            <span style="margin-left: 5rem"> All </span>
          </button>

          <button
            mat-menu-item
            routerLink="ebu/engines/sales-realization/industrial"
            (click)="setActiveItem('industrial')"
            [ngStyle]="{
              background: activeItem === 'industrial' ? '#950101' : ''
            }"
          >
            <span style="margin-left: 5rem"> Industrial </span>
          </button>

          <button
            mat-menu-item
            routerLink="ebu/engines/sales-realization/onHighway"
            (click)="setActiveItem('onHighway')"
            [ngStyle]="{
              background: activeItem === 'onHighway' ? '#950101' : ''
            }"
          >
            <span style="margin-left: 5rem"> On Highway </span>
          </button>

          <button
            mat-menu-item
            routerLink="ebu/engines/sales-realization/powerGen"
            (click)="setActiveItem('power-gen')"
            [ngStyle]="{
              background: activeItem === 'power-gen' ? '#950101' : ''
            }"
          >
            <span style="margin-left: 5rem"> Power Gen </span>
          </button>

          <button
            mat-menu-item
            routerLink="ebu/engines/detailed-sales"
            (click)="setActiveItem('detail')"
            [ngStyle]="{
              background: activeItem === 'detail' ? '#950101' : ''
            }"
          >
            <span>
              <mat-icon>zoom_in</mat-icon>
              Detailed SalesRealization
            </span>
          </button>
          <button
            mat-menu-item
            routerLink="ebu/engines/sales-contribution"
            (click)="setActiveItem('sales')"
            [ngStyle]="{
              background: activeItem === 'sales' ? '#950101' : ''
            }"
          >
            <span>
              <mat-icon>zoom_in</mat-icon>
             Contribution to sales
            </span>
          </button>
          <button
            mat-menu-item
            routerLink="ebu/engines/deep-dive"
            (click)="setActiveItem('product')"
            [ngStyle]="{
              background: activeItem === 'product' ? '#950101' : ''
            }"
          >
            <span>
              <mat-icon>zoom_in</mat-icon>
              Driver's Of Product Mix
            </span>
          </button>
          <button
            mat-menu-item
            routerLink="ebu/engines/summary"
            (click)="setActiveItem('summary')"
          >
            <span
              [ngStyle]="{
                color: activeItem === 'summary' ? '#950101' : ''
              }"
            >
              <mat-icon>list_alt</mat-icon>

              Summary
            </span>
          </button>
        </div>
      </mat-menu>
    </div>

    <div class="block" *ngIf="currentPage.includes('/power-systems/engines')">
      <mat-icon class="content" [matMenuTriggerFor]="country"
        >format_indent_increase</mat-icon
      >
      <mat-menu #country="matMenu">
        <div class="plMenuCSS">
          <button mat-menu-item>
            <mat-icon>format_indent_decrease</mat-icon>close panel
          </button>
          <button
            mat-menu-item
            routerLink="power-systems/engines/sales-realization"
            (click)="setActiveItem('sales')"
            [ngStyle]="{
              background: activeItem === 'sales' ? '#950101' : ''
            }"
          >
            <span>
              <mat-icon>price_change</mat-icon>
              Sales Realization
            </span>
          </button>
          <!-- <button
            mat-menu-item
            routerLink="power-systems/engines/summary"
            (click)="setActiveItem('summary')"
            [ngStyle]="{
              background: activeItem === 'summary' ? '#950101' : ''
            }"
          >
            <span>
              <mat-icon>list_alt</mat-icon>

              Summary
            </span>
          </button> -->
          <button
            mat-menu-item
            routerLink="power-systems/engines/t-chart"
            (click)="setActiveItem('tchart')"
            [ngStyle]="{
              background: activeItem === 'tchart' ? '#950101' : ''
            }"
          >
            <span>
              <mat-icon> insert_chart_outlined</mat-icon>
              T Chart
            </span>
          </button>
          <button
            mat-menu-item
            routerLink="power-systems/engines/wave-initiative"
            (click)="setActiveItem('wave-initiative')"
            [ngStyle]="{
              background: activeItem === 'wave-initiative' ? '#950101' : ''
            }"
          >
            <span>
              <mat-icon>line_weight</mat-icon>
              wave-initiative
            </span>
          </button>
          <button
            mat-menu-item
            routerLink="power-systems/engines/regional-summary"
            (click)="setActiveItem('regional-summary')"
            [ngStyle]="{
              background: activeItem === 'regional-summary' ? '#950101' : ''
            }"
          >
            <span>
              <mat-icon>view_quilt</mat-icon>
              Regional Summary
            </span>
          </button>
          <button
            mat-menu-item
            routerLink="power-systems/engines/hhp/deep-down"
            (click)="setActiveItem('deep')"
            [ngStyle]="{
              background: activeItem === 'deep' ? '#950101' : ''
            }"
          >
            <span>
              <mat-icon>zoom_in</mat-icon>
              Deep Dive
            </span>
          </button>
        </div>
      </mat-menu>
    </div>

    <div class="block" *ngIf="currentPage.includes('/power-systems/margin-realization')">
      <mat-icon class="content" [matMenuTriggerFor]="country">format_indent_increase</mat-icon>
      <mat-menu #country="matMenu">
        <div class="plMenuCSS">
          <button mat-menu-item>
            <mat-icon>format_indent_decrease</mat-icon>close panel
          </button>
          <button mat-menu-item routerLink="power-systems/margin-realization" (click)="setActiveItem('margin')" [ngStyle]="{
                  background: activeItem === 'margin' ? '#950101' : ''
                }">
            <span>
              <mat-icon>price_change</mat-icon>
              Margin Realization
            </span>
          </button>
    
          <button mat-menu-item routerLink="power-systems/margin-realization/deep-down" (click)="setActiveItem('deep')"
            [ngStyle]="{
                  background: activeItem === 'deep' ? '#950101' : ''
                }">
            <span>
              <mat-icon>zoom_in</mat-icon>
              Deep Dive
            </span>
          </button>
        </div>
      </mat-menu>
    </div>

    <div class="block" *ngIf="currentPage.includes('/power-systems/power-gen')">
      <mat-icon class="content" [matMenuTriggerFor]="country"
        >format_indent_increase</mat-icon
      >
      <mat-menu #country="matMenu">
        <div class="plMenuCSS">
          <button mat-menu-item>
            <mat-icon>format_indent_decrease</mat-icon>close panel
          </button>
          <button
            mat-menu-item
            routerLink="power-systems/power-gen/sales-realization"
            (click)="setActiveItem('sales')"
            [ngStyle]="{
              background: activeItem === 'sales' ? '#950101' : ''
            }"
          >
            <span>
              <mat-icon>price_change</mat-icon>
              Sales Realization
            </span>
          </button>
          <button
            mat-menu-item
            routerLink="power-systems/power-gen/summary"
            (click)="setActiveItem('summary')"
            [ngStyle]="{
              background: activeItem === 'summary' ? '#950101' : ''
            }"
          >
            <span>
              <mat-icon>list_alt</mat-icon>

              Summary
            </span>
          </button>
          <button
            mat-menu-item
            routerLink="power-systems/power-gen/deep-dive"
            (click)="setActiveItem('deep')"
            [ngStyle]="{
              background: activeItem === 'deep' ? '#950101' : ''
            }"
          >
            <span>
              <mat-icon>zoom_in</mat-icon>
              Deep Dive
            </span>
          </button>
        </div>
      </mat-menu>
    </div>
  </div>
</nav>
